import axios from 'axios';
import moment from 'moment';
import { Survey, Question } from './SurveyUtils';
import { ServiceProvider } from './ProviderUtils';
import { User } from './UserUtils';

interface Log {
  id: number;
  survey: Partial<Survey>;
  serviceprovider: Partial<ServiceProvider>;
  question: Partial<Question>;
  user: Partial<User>;
  action: string;
  data: any;
  date: string;
  ip: string;
  browser: string;
}
const api = {
  instance: {
    list: async (params?: {
      serviceprovidername?: string;
      username?: string;
      startdate?: string;
      enddate?: string;
      tableParams?: any;
    }) => {
      const resp = await axios.get<{
        count: number;
        result: Log[];
      }>('/logging/list.php', {
        params: params,
      });
      let results = resp.data.result.map((log) => generateLog(log));
      resp.data.result = results;
      return resp.data;
    },
    get: async (id: number) => {
      const resp = await axios.get<Log>('/logging/get.php', {
        params: { id: id },
      });
      return generateLog(resp.data);
    },
  },
};

const generateLog = (json: any): Log => {
  const log: Log = {
    ...json,
    date: json.date
      ? moment(json.date)
          .local()
          .format('YYYY-MM-DD HH:mm:ss') // convert to local timezone when reading from api
      : // NOTE: if time picker is needed, split startdate into startdate and starttime (so a timepicker component can be used) and merge when sending to api
        undefined,
  };
  return log;
};

export default {
  api,
};
export { Log };
